<template>
  <v-container fluid>

    <v-row dense align="center" justify="space-between" no-gutters>
      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle ml-10">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
        <v-col  cols="12" md="3" sm="12" xs="12">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <v-col cols="12" md="3" sm="12" xs="12">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      <v-col cols="12" md="3" sm="12" xs="12" >
        <optiondialog :optionname="SEARCH_OPTION_NAME" :comidx="SEARCH_COM_IDX" :eventidx="SEARCH_EVENT_IDX" @callback="optionsearchcb"></optiondialog>
      </v-col>

    </v-row>

    <v-row align="center" dense>
      <v-spacer/>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="12" md="2" sm="12" xs="12">                      
        <v-menu
          v-model="date2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_end_date"
              :label="$t('common_search_end')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_end_date" @input="date2=false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>                    
      </v-col>
      <v-col cols="12" md="1" sm="6" xs="6" class="d-flex justify-center">
        <v-checkbox v-model="checkdate" dense :label="$t('adminstat_label1')"/>
      </v-col>
      <v-col cols="12" md="2" sm="6" xs="6" class="d-flex justify-center">
        <v-btn class="search_btn" elevation="0" outlined large @click="search_run">{{$t("common_ok")}}</v-btn>
        <v-btn class="ml-2" color="#4e6ef7" large rounded @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px"> 
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('adminstat_col1')}}</label>
          <label class="chartsum_value">{{sum1}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('adminstat_col2')}}</label>
        <label class="chartsum_value">{{sum2}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('adminstat_col3')}}</label>
        <label class="chartsum_value">{{sum3}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('adminstat_col4')}}</label>
        <label class="chartsum_value">{{sum4}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('adminstat_col5')}}</label>
        <label class="chartsum_value">{{sum5}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('adminstat_col6')}}</label>
        <label class="chartsum_value">{{sum6}}</label>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col>
        <v-simple-table 
          height="40vh"
          dense fixed-header
          class="datatablestyle"
          >
          <template v-slot:default>
            <thead style="height:48px">
              <tr>
                <th class="text-center header_text_style">{{$t('adminstat_col7')}}</th>
                <th class="text-center header_text_style">{{$t('adminstat_col1')}}</th>
                <th class="text-center header_text_style">{{$t('adminstat_col2')}}</th>
                <th class="text-center header_text_style">{{$t('adminstat_col3')}}</th>
                <th class="text-center header_text_style">{{$t('adminstat_col4')}}</th>
                <th class="text-center header_text_style">{{$t('adminstat_col5')}}</th>
                <th class="text-center header_text_style">{{$t('adminstat_col6')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="background-color:#f0f0f0">
                <td class="text-center">합계</td>
                <td class="text-center">{{ priceToString(sum1) }}</td>
                <td class="text-center">{{ priceToString(sum2) }}</td>
                <td class="text-center">{{ priceToString(sum3) }}</td>
                <td class="text-center">{{ priceToString(sum4) }}</td>
                <td class="text-center">{{ priceToString(sum5) }}</td>
                <td class="text-center">{{ priceToString(sum6) }}</td>
              </tr>
              <tr v-for="item in list" :key="item.REG_DATE">
                <td class="text-center">{{ item.REG_DATE }}</td>
                <td class="text-center">{{ priceToString(item.STEP1) }}</td>
                <td class="text-center">{{ priceToString(item.STEP2) }}</td>
                <td class="text-center">{{ priceToString(item.STEP3) }}</td>
                <td class="text-center">{{ priceToString(item.STEP4) }}</td>
                <td class="text-center">{{ priceToString(item.STEP5) }}</td>
                <td class="text-center">{{ priceToString(item.STEP6) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" sm="6" xs="6">
        <canvas ref="drawarea2" style="width:95%"/>
      </v-col>
      <v-col cols="12" md="6" sm="6" xs="6">
        <canvas ref="drawarea" style="width:95%"/>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import moment from 'moment'
import XLSX from 'xlsx'
export default {

  beforeDestroy(){

    //차트 초기화 - 제대로 안지우면 인스턴스 계속 쌓인다.
    if(this.myChart1 != null){
      this.myChart1.destroy();
    }
    if(this.myChart2 != null){
      this.myChart2.destroy();
    }

  },

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
    this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
    this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
    this.SEARCH_OPTION_IDX  = this.$session.get("OPTION_IDX");
    this.SEARCH_OPTION_NAME = this.$session.get("OPTION_NAME");
    this.grade = this.$session.get("GRADE");

    this.search_start_date  = this.$session.get("EVENT_START");
    if(this.search_start_date == null || this.search_start_date == undefined){
      this.search_start_date = moment().subtract(1, 'YEARS').format("YYYY-MM-DD");
    }
    this.search_end_date    = this.$session.get("EVENT_END");
    if(this.search_end_date == null || this.search_end_date == undefined){
      this.search_end_date   = moment().format("YYYY-MM-DD");
    }

    //Chart.register(ChartDataLabels);

    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },

  data: () => ({
      myChart1: null,
      myChart2: null,
      date1:false,
      date2:false,
      search_start_date : '',
      search_end_date : '',
      checkdate : true,
      list:[],
      sum1:0,
      sum2:0,
      sum3:0,
      sum4:0,
      sum5:0,
      sum6:0,

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      SEARCH_OPTION_IDX: null,
      SEARCH_OPTION_NAME: '',
      grade : 0,

  }),

  methods: {

    priceToString(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    insertAt(array, index, item) {
      array.splice(index, 0, item);
    },

    startDownload(){

      this.$confirm(this.$t("adminstat_msg1")).then(() => {
        
        //var templist = this.list.slice();
        var templist = [];
        this.list.forEach(item=>{
          templist.push({"REG_DATE":item.REG_DATE, "STEP1":item.STEP1, "STEP2":item.STEP2, "STEP3":item.STEP3, "STEP4":item.STEP4, "STEP5":item.STEP5, "STEP6":item.STEP6});
        });

        //하단 합계 넣기
        templist.push({"REG_DATE":this.$t("adminstat_label2"), "STEP1":this.sum1, "STEP2":this.sum2, "STEP3":this.sum3, "STEP4":this.sum4, "STEP5":this.sum5, "STEP6":this.sum6});
        
        var item_sheet = XLSX.utils.json_to_sheet(templist);

        //상단 컬럼명 수정
        item_sheet.A1 = {v:this.$t("adminstat_col7")};
        item_sheet.B1 = {v:this.$t("adminstat_col1")};
        item_sheet.C1 = {v:this.$t("adminstat_col2")};
        item_sheet.D1 = {v:this.$t("adminstat_col3")};
        item_sheet.E1 = {v:this.$t("adminstat_col4")};
        item_sheet.F1 = {v:this.$t("adminstat_col5")};
        item_sheet.G1 = {v:this.$t("adminstat_col6")};

        //컬럼별 너비
        var wscols = [{wch:20},{wch:10},{wch:10},{wch:10},{wch:10},{wch:10},{wch:10}];
        item_sheet['!cols'] = wscols;

        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, item_sheet, this.$t("adminstat_msg2"));
        XLSX.writeFile(wb, this.$t("adminstat_msg3")+"_"+moment().format('YYYYMMDDHHmmss')+'.xlsx');

      });

    },

    initpage(){

      this.search_run();

    },

    search_run(){

        if(this.grade < 99){
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }
        }

        if(this.search_start_date.length < 4){
          this.$alert(this.$t('common_search_start_info1'));
          return;
        }
        if(this.search_end_date.length < 4){
          this.$alert(this.$t('common_search_end_info1'));
          return;
        }
        if(this.search_start_date > this.search_end_date){
          this.$alert(this.$t('common_search_date_error1'));
          return;
        }

      this.$http.post(this.$host+'/api/ChartUserList',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX == undefined ? '' : this.SEARCH_COM_IDX
          , EVENT_IDX: this.SEARCH_EVENT_IDX == undefined ? '' : this.SEARCH_EVENT_IDX
          , OPTION_IDX: this.SEARCH_OPTION_IDX == undefined ? '' : this.SEARCH_OPTION_IDX
          , CHECKDATE: this.checkdate
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
          , LAN_CODE:this.$i18n.locale
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{

        
        this.loading = false;
        
        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            //chart.js로 차트를 그린다. 캔버스를 읽어서 차트객체를 만들어주면 알아서 생성된다.
            const ctx1 = this.$refs.drawarea;
            const ctx2 = this.$refs.drawarea2;

            //캔버스 초기화
            if(this.myChart1 != null){
              this.myChart1.destroy();
            }
            if(this.myChart2 != null){
              this.myChart2.destroy();
            }
            //ctx2.getContext("2d").clearRect(0, 0, ctx2.width, ctx2.height);
            this.list.splice(0, this.list.length);   //데이터 초기화
            this.list = result.data.resultData;
            const datanames = [];
            const step1 = []; 
            const step2 = []; 
            const step3 = []; 
            const step4 = []; 
            const step5 = []; 
            const step6 = []; 
            this.sum1 = 0;
            this.sum2 = 0;
            this.sum3 = 0;
            this.sum4 = 0;
            this.sum5 = 0;
            this.sum6 = 0;

            if(this.checkdate){
              this.list.slice().reverse().forEach(element => {
                datanames.push(element.REG_DATE);
                step1.push(element.STEP1);
                step2.push(element.STEP2);
                step3.push(element.STEP3);
                step4.push(element.STEP4);
                step5.push(element.STEP5);
                step6.push(element.STEP6);
                this.sum1 += parseInt(element.STEP1);
                this.sum2 += parseInt(element.STEP2);
                this.sum3 += parseInt(element.STEP3);
                this.sum4 += parseInt(element.STEP4);
                this.sum5 += parseInt(element.STEP5);
                this.sum6 += parseInt(element.STEP6);
              });

              const datas = {
                labels:datanames, //차트 하단에 표시됨
                datasets:[
                    {label:this.$t("adminstat_col1"),  data:step1, backgroundColor: 'rgb(9, 156, 253)',borderColor: 'rgb(9, 156, 253)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col2"),  data:step2, backgroundColor: 'rgb(129, 66, 255)',borderColor: 'rgb(129, 66, 255)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col3"),  data:step3, backgroundColor: 'rgb(255, 67, 107)',borderColor: 'rgb(255, 67, 107)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col4"),  data:step4, backgroundColor: 'rgb(14, 52, 91)',borderColor: 'rgb(14, 52, 91)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col5"),  data:step5, backgroundColor: 'rgb(67, 164, 157)',borderColor: 'rgb(67, 164, 157)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col6"),  data:step6, backgroundColor: 'rgb(255, 215, 0)',borderColor: 'rgb(255, 215, 0)', lineTension:0.3, fill: false,}
                ],
              };

              const options = {
                plugins: {
                    title: {
                        display: true,
                        text: this.$t("adminstat_msg2")
                    },
                    legend: { 
                        position: 'right' 
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: false,
                    },
                },                
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                        display: true,
                        ticks:{reverse:true},
                        scaleLabel: {
                            display: true,
                            labelString: this.$t("adminstat_msg4")
                        }
                    }],
                    yAxes: [{
                        display: true,
                        ticks: {
                            suggestedMin: 0,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.$t("adminstat_msg5")
                        }
                    }]
                },    
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio : 2
              };     

              //차트 객체에는 캔버스 객체와 타입, 데이터, 옵션이 들어간다.
              //eslint-disable-next-line no-unused-vars
              
              this.myChart1 = new Chart(ctx1, {type:'line', data:datas, options: options});

              const pie1 = []; //접수
              pie1.push(this.sum1);
              pie1.push(this.sum2);
              pie1.push(this.sum3);
              pie1.push(this.sum4);
              pie1.push(this.sum5);
              pie1.push(this.sum6);
              const tcnt = this.sum1+this.sum2+this.sum3+this.sum4+this.sum5+this.sum6;
              const datas2 = {
                labels:[this.$t("adminstat_col1"),this.$t("adminstat_col2"),this.$t("adminstat_col3"),this.$t("adminstat_col4"),this.$t("adminstat_col5"),this.$t("adminstat_col6")],
                datasets:[
                    { data:pie1,  backgroundColor: ['rgb(9, 156, 253)','rgb(129, 66, 255)','rgb(255, 67, 107)','rgb(14, 52, 91)','rgb(67, 164, 157)','rgb(255, 215, 0)'], borderColor: ['rgb(9, 156, 253)', 'rgb(129, 66, 255)', 'rgb(255, 67, 107)','rgb(14, 52, 91)','rgb(67, 164, 157)','rgb(255, 215, 0)']}
                ],
              };

              const options2 = {
                plugins: {
                    datalabels: {
                      color: '#ffffff',
                      backgroundColor: '#00000080',
                      //차트 기본 표시정보 재정의
                      formatter:function(value){
                        var rdata = Math.round(parseInt(value)/(parseInt(tcnt))*100);
                        return value+" ("+rdata+"%)";
                      },
                      //0값은 표시 안함
                      display: function(context) {
                          return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
                      }
                    },          
                    tooltip:{ 
                      callbacks:{ 
                        //eslint-disable-next-line no-unused-vars
                        label:function(context){ 
                          var value1 = context.formattedValue;
                          var rdata = Math.round(parseInt(value1)/(parseInt(tcnt))*100);
                          return context.label +" " + value1 + " ("+ rdata.toFixed(1)+"%)";
                        }
                      }
                    },                                    
                    title: {
                        display: true,
                        text: this.$t("adminstat_msg2")
                    },
                    legend: { 
                        position: 'right' 
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: false,
                    },
                },                
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                        display: false,
                        scaleLabel: {
                            display: false,
                            labelString: this.$t("adminstat_msg4")
                        }
                    }],
                    yAxes: [{
                        display: false,
                        ticks: {
                            suggestedMin: 0,
                        },
                        scaleLabel: {
                            display: false,
                            labelString: this.$t("adminstat_msg5")
                        }
                    }]
                },    
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio : 2
              };     
              this.myChart2 = new Chart(ctx2, {type:'pie', data:datas2, options: options2, plugins:[ChartDataLabels]});

            }else{

              const step1 = []; //접수
              datanames.push(this.$t("adminstat_msg6"));
              step1.push(result.data.resultData[0].STEP1);
              step1.push(result.data.resultData[0].STEP2);
              step1.push(result.data.resultData[0].STEP3);
              step1.push(result.data.resultData[0].STEP4);
              step1.push(result.data.resultData[0].STEP5);
              step1.push(result.data.resultData[0].STEP6);
              this.sum1 = result.data.resultData[0].STEP1;
              this.sum2 = result.data.resultData[0].STEP2;
              this.sum3 = result.data.resultData[0].STEP3;
              this.sum4 = result.data.resultData[0].STEP4;
              this.sum5 = result.data.resultData[0].STEP5;
              this.sum6 = result.data.resultData[0].STEP6;

              const tcnt = this.sum1+this.sum2+this.sum3+this.sum4+this.sum5+this.sum6;
              const datas = {
                labels:datanames, //차트 하단에 표시됨
                datasets:[
                    {label:this.$t("adminstat_col1"), data:[this.sum1], backgroundColor: 'rgb(9, 156, 253)',borderColor: 'rgb(9, 156, 253)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col2"), data:[this.sum2], backgroundColor: 'rgb(129, 66, 255)',borderColor: 'rgb(129, 66, 255)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col3"), data:[this.sum3], backgroundColor: 'rgb(255, 67, 107)',borderColor: 'rgb(255, 67, 107)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col4"), data:[this.sum4], backgroundColor: 'rgb(14, 52, 91)',borderColor: 'rgb(14, 52, 91)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col5"), data:[this.sum5], backgroundColor: 'rgb(67, 164, 157)',borderColor: 'rgb(67, 164, 157)', lineTension:0.3, fill: false,}
                  , {label:this.$t("adminstat_col6"), data:[this.sum6], backgroundColor: 'rgb(255, 215, 0)',borderColor: 'rgb(255, 215, 0)', lineTension:0.3, fill: false,}
                ],
              };
                
              const options = {
                title: {
                    display: true,
                    text: this.$t("adminstat_msg2")
                },              
                tooltips: {
                    mode: 'index',
                    intersect: false,
                },
                legend: { 
                    position: 'right' 
                },
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                        display: true,
                        ticks:{reverse:true},
                        scaleLabel: {
                            display: true,
                            labelString: this.$t("adminstat_msg4")
                        }
                    }],
                    yAxes: [{
                        display: true,
                        ticks: {
                            suggestedMin: 0,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.$t("adminstat_msg5")
                        }
                    }]
                },    
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio : 2
              };     
              this.myChart1 = new Chart(ctx1, {type:'bar', data:datas, options: options});              

              const datas2 = {
                labels:[this.$t("adminstat_col1"),this.$t("adminstat_col2"),this.$t("adminstat_col3"),this.$t("adminstat_col4"),this.$t("adminstat_col5"),this.$t("adminstat_col6")],
                datasets:[
                    { data:step1, backgroundColor: ['rgb(9, 156, 253)','rgb(129, 66, 255)','rgb(255, 67, 107)','rgb(14, 52, 91)','rgb(67, 164, 157)','rgb(255, 215, 0)'], borderColor: ['rgb(9, 156, 253)', 'rgb(129, 66, 255)', 'rgb(255, 67, 107)','rgb(14, 52, 91)','rgb(67, 164, 157)','rgb(255, 215, 0)']}
                ],
              };

              const options2 = {
                plugins:{
                  datalabels: {
                    color: '#ffffff',
                    backgroundColor: '#00000080',
                    //차트 기본 표시정보 재정의
                    formatter:function(value){
                      var rdata = Math.round(parseInt(value)/(parseInt(tcnt))*100);
                      return value+" ("+rdata+"%)";
                    },
                    //0값은 표시 안함
                    display: function(context) {
                        return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
                    }
                  },          
                  tooltip:{ 
                    callbacks:{ 
                      //eslint-disable-next-line no-unused-vars
                      label:function(context){ 
                        var value1 = context.formattedValue;
                        var rdata = Math.round(parseInt(value1)/(parseInt(tcnt))*100);
                        return context.label +" " + value1 + " ("+ rdata.toFixed(1)+"%)";
                      }
                    }
                  },                                    
                  title: {
                      display: true,
                      text: this.$t("adminstat_msg2")
                  },              
                  legend: { 
                      position: 'right' 
                  },
                },
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                        display: false,
                        scaleLabel: {
                            display: false,
                            labelString: this.$t("adminstat_msg4")
                        }
                    }],
                    yAxes: [{
                        display: false,
                        ticks: {
                            suggestedMin: 0,
                        },
                        scaleLabel: {
                            display: false,
                            labelString: this.$t("adminstat_msg5")
                        }
                    }]
                },    
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio : 2
              };     
              //eslint-disable-next-line no-unused-vars
              this.myChart2 = new Chart(ctx2, {type:'pie', data:datas2, options: options2, plugins:[ChartDataLabels]});

            }

        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        
        this.loading = false;
      });

    },


    //입장료 옵션 선택 콜백
    optionsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_OPTION_NAME = val1.NAME;
        this.SEARCH_OPTION_IDX  = val1.IDX;
        this.$session.set("OPTION_IDX", val1.IDX);
        this.$session.set("OPTION_NAME",val1.NAME);
      }else{
        this.SEARCH_OPTION_NAME = "";
        this.SEARCH_OPTION_IDX  = null;
        this.$session.set("OPTION_IDX", null);
        this.$session.set("OPTION_NAME", "");
      }
      this.search_run();
    },


    //검색조건 업체 설정
    eventsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_EVENT_NAME = val1.NAME;
        this.SEARCH_EVENT_IDX  = val1.IDX;
        this.SEARCH_OPTION_IDX = null;
        this.SEARCH_OPTION_NAME = '';
        this.$session.set("EVENT_IDX", val1.IDX);
        this.$session.set("EVENT_NAME",val1.NAME);
        this.$session.set("OPTION_IDX", null);
        this.$session.set("OPTION_NAME",'');

        this.search_start_date = moment(val1.EVENT_START, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.search_end_date  = moment(val1.EVENT_END, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.$session.set("EVENT_START", this.search_start_date);
        this.$session.set("EVENT_END", this.search_end_date);

      }else{
        this.SEARCH_EVENT_NAME = "";
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_OPTION_IDX = null;
        this.SEARCH_OPTION_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.$session.set("OPTION_IDX", null);
        this.$session.set("OPTION_NAME",'');

        this.$session.set("EVENT_START", null);
        this.$session.set("EVENT_END", null);

      }
      this.search_run();
    },

    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.search_run();
    },

    //업체선택 콜백
    comdialogcb(val){
      if(val.NAME.length > 0){
        this.editedItem.COM_NAME = val.NAME;
        this.editedItem.COM_IDX  = val.IDX;
      }else{
        this.$alert(this.$t('common_select_company'));
        return;
      }
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>